import { Injectable, HostListener } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false
	public fullScreen = false;
	MENUITEMS: Menu[] = []
	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

	constructor(private afs: AngularFirestore) {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}

		const user = JSON.parse(localStorage.getItem('user'));

		this.afs.doc(`users/${user.uid}`).get().forEach((user: any) => {
			if (user.data().typeUser === 'SUPERADMIN') {
				this.MENUITEMS.push(
					// {
					// 	title: 'Dashboard', icon: 'home', type: 'link', badgeType: 'primary', active: true, path: '/dashboard/e-commerce'
					// },
					{
						title: 'POS', icon: 'shopping-bag', type: 'link', badgeType: 'primary', active: true, path: '/pos'
					},
					{
						title: 'Productos', icon: 'archive', type: 'sub', active: false, children: [
							{ path: '/products/create', title: 'Crear', type: 'link' },
							{ path: '/products/list', title: 'Listar', type: 'link' },
							{ path: '/products/categories', title: 'Categorías', type: 'link' },
							{ path: '/products/attributes', title: 'Atributos', type: 'link' }
						]
					},
					// {
					// 	title: 'Cambio producto', icon: 'repeat', type: 'link', badgeType: 'primary', active: true, path: '/sales'
					// },
					{
						title: 'Reportes', icon: 'file-text', type: 'link', badgeType: 'primary', active: true, path: '/reports'
					},
					{
						title: 'Métodos de pago', icon: 'credit-card', type: 'link', active: false, path: '/payment-methods/create'
					},

					{
						title: 'Usuarios', icon: 'user', type: 'link', active: false, path: '/users/create'
					},
					{
						title: 'Sucursales', icon: 'database', type: 'link', active: false, path: '/subsidiaries/create'
					},
				)
			} else if (user.data().typeUser === 'CASHIER') {
				this.MENUITEMS.push(
					{
						title: 'POS', icon: 'shopping-bag', type: 'link', badgeType: 'primary', active: true, path: '/pos'
					},
					{
						title: 'Cambio producto', icon: 'repeat', type: 'link', badgeType: 'primary', active: true, path: '/sales'
					},
					{
						title: 'Productos', icon: 'archive', type: 'sub', active: false, children: [
							{ path: '/products/create', title: 'Crear', type: 'link' },
							{ path: '/products/list', title: 'Listar', type: 'link' },
							{ path: '/products/categories', title: 'Categorías', type: 'link' },
							{ path: '/products/attributes', title: 'Atributos', type: 'link' }
						]
					},
				)
			}
		})
	}

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}



}
